import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';

export class Metas{
  public indicatorId?: Number;
  public period?: Date;
  public value?: Number;
  public real?: Number;
}

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  constructor(
    private http: HttpClient, 
    private cookies: CookieService,
    private apollo: Apollo
  ) { }

  public postMetas(meta: any): Observable<any>{
    const met: Metas = {
      indicatorId: Number(meta.indicatorId),
      period: meta.nombre.toISOString(),
      value: Number(meta.descripcion),
    }
    const body = JSON.stringify(met);
    const apiURL = this.apiURL+"meta";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }

  public patchMetas(meta: any): Observable<any>{
    const met: Metas = {
      indicatorId: Number(meta.indicatorId),
      period: meta.nombre.toISOString(),
      value: Number(meta.descripcion),
    }
    const body = JSON.stringify(met);
    const apiURL = this.apiURL+"meta/"+Number(meta.id);
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }

  public patchMetasReal(meta: any): Observable<any>{
      const met: Metas = {
        real: meta.real,
      }
      const body = JSON.stringify(met);
      const apiURL = this.apiURL+"meta/"+Number(meta.id);
      return this.http.patch(`${apiURL}`, body, {headers: this.headers});
    }

  public deleteMetas(meta: any): Observable<any>{
    const apiURL = this.apiURL+"meta/"+Number(meta.id);
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
}
